<template>
  <div>
    <b-sidebar
      :visible="showDateClickedPanel"
      no-header-close
      right
      backdrop
      no-close-on-backdrop
      @change="onSidebarVisibilityChange"
    >
      <template #header>
        <b-row align-v="center" class="w-100 mt-2">
          <b-col align-h="start" cols="2">
            <button
              @click.prevent="closePanel()"
              type="button"
              class="close"
              aria-label="Fechar"
            >
              <span @click.prevent="closePanel()" class="no no-e-remove"></span>
            </button>
          </b-col>

          <div class="ml-auto mb-2">
            <div>
              <b-button
                @click.prevent="editAvailability()"
                :disabled="hasDatePassed && poisList.length == 0"
                :variant="
                  poisList.length > 1 || isDateBlocked
                    ? 'outline-primary'
                    : 'outline-primary'
                "
                size="sm"
              >
                <!-- {{ poisList.length > 1 ? 'Editar disponibilidade' : isDateBlocked ? 'Desbloquear dia' : 'Bloquear dia' }} -->
                disponibilidade
              </b-button>
            </div>
          </div>
        </b-row>
      </template>

      <div class="pr-4 pl-4">
        <div
          align-h="center"
          class="d-flex justify-content-between align-items-center"
        >
          <b-button
            @click.prevent="prevDay"
            class="fullcalendar-btn-prev btn"
            variant="letters"
          >
            <i style="color: #12576e" class="fas fa-angle-left"></i>
          </b-button>

          <h2 class="ml-0 mr-0 mb-0" style="color: #12576e">
            {{ formatDate(selectedDate, 'DD [de] MMMM [de] YYYY') }}
          </h2>

          <b-button
            @click.prevent="nextDay"
            class="fullcalendar-btn-next btn"
            variant="letters"
          >
            <i style="color: #12576e" class="fas fa-angle-right"></i>
          </b-button>
        </div>

        <div align-v="center" class="pr-2 pl-2">
          <day-summary
            :bookings="bookings"
            :selectedDate="selectedDate"
          ></day-summary>
        </div>
      </div>
    </b-sidebar>

    <modal-editar-disponibilidade
      v-if="showEditAvaialabilityModal"
      :showEditAvaialabilityModal="showEditAvaialabilityModal"
      @emitCloseAvaialabilityModal="closeAvaialabilityModal"
      @emitReloadPois="loadPois"
    >
    </modal-editar-disponibilidade>
  </div>
</template>

<script>
import moment from 'moment'
import swal from 'sweetalert2'
import { mapGetters, mapActions } from 'vuex'
import ModalEditarDisponibilidade from './ModalEditarDisponibilidade.vue'
import DaySummary from './DaySummary.vue'
import { computed } from 'vue'

export default {
  name: 'ReservaDetalheSidebar',

  components: {
    ModalEditarDisponibilidade,
    DaySummary,
  },

  props: {
    showDateClickedPanel: {
      type: Boolean,
      default: false,
    },
  },

  inject: ['isLoading', 'selectedDate', 'bookings'],

  computed: {
    ...mapGetters('product', {
      poisList: 'getPois',
    }),

    ...mapGetters('auth', {
      place: 'getPlace',
    }),

    formattedSelectedDate() {
      return this.formatDate(this.selectedDate, 'DD/MM/YYYY')
    },

    hasDatePassed() {
      return moment(this.selectedDate).isBefore(moment())
    },

    isDateBlocked() {
      if (this.poisList.length == 0 || this.poisList.length > 1) {
        return false
      }
      if (this.poisList.length == 1) {
        return Object.keys(this.poisList[0].unavailability).includes(
          this.selectedDate
        )
      }
    },
  },

  watch: {},

  data() {
    return {
      showModalTabelaReservas: false,
      showEditAvaialabilityModal: false,
    }
  },

  provide() {
    return {
      startDate: computed(() => this.selectedDate),
      endDate: computed(() => this.selectedDate),
    }
  },

  methods: {
    ...mapActions('product', ['fetchPOIs']),

    ...mapActions('operacao', [
      'blockDayProduct',
      'unblockDayProduct',
      'formatDaySummary',
    ]),

    formatDate(date, format) {
      return moment(date).format(format)
    },

    closePanel() {
      this.$emit('closePanel')
    },

    onSidebarVisibilityChange(visible) {
      if (!visible) {
        this.closePanel()
      }
    },

    nextDay() {
      this.$emit('emitNextDayPanel')
    },
    prevDay() {
      this.$emit('emitPrevDayPanel')
    },

    closeAvaialabilityModal() {
      this.showEditAvaialabilityModal = false
    },

    isPoiAvaialable(poi) {
      const unavailability = Object.keys(poi.unavailability)
      return !unavailability.includes(this.selectedDate)
    },

    editAvailability() {
      if (this.poisList.length == 1 && !this.isDateBlocked) {
        this.blockDay()
      }
      if (this.poisList.length == 1 && this.isDateBlocked) {
        this.unblockDay(this.poisList[0])
      }
      if (this.poisList.length > 1) {
        this.showEditAvaialabilityModal = true
      }
    },

    async blockDay() {
      const poi = this.poisList.find((i) => i.uuid)
      const dayToBlock = this.formattedSelectedDate

      swal
        .fire({
          title: `Bloquear o dia ${dayToBlock}?`,
          text: `${poi.product_place_name}: ${poi.product_name}`,
          showCancelButton: true,
          confirmButtonText: 'Bloquear',
          confirmButtonColor: '#D93051',
          cancelButtonText: 'Fechar',
          reverseButtons: true,
          cancelButtonColor: 'secondary',
          type: 'default',
        })
        .then((result) => {
          if (result.isConfirmed) {
            const UUID = poi.uuid
            const unavailability = { [this.selectedDate]: [{ ticket: '*' }] }

            this.blockDayProduct({
              product_uuid: UUID,
              unavailability: unavailability,
            }).then(async () => {
              await this.loadPois()
              this.closePanel()
              this.$notify({
                message: 'Reservas bloqueadas para: ' + dayToBlock,
                duration: 6000,
                type: 'success',
              })
            })
          }
        })
    },

    async unblockDay(poi) {
      const dayToUnlock = this.formattedSelectedDate

      swal
        .fire({
          title: `Desbloquear o dia ${this.formatDate(
            this.selectedDate,
            'DD/MM/YYYY'
          )} ?`,
          text: `${poi.product_place_name}: ${poi.product_name}`,
          showCancelButton: true,
          confirmButtonText: 'Desbloquear',
          confirmButtonColor: '#A7AA37',
          cancelButtonText: 'Fechar',
          reverseButtons: true,
          cancelButtonColor: 'secondary',
          type: 'default',
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            const unavailability = { [this.selectedDate]: [{ ticket: '*' }] }
            await this.unblockDayProduct({
              product_uuid: poi.uuid,
              unavailability: unavailability,
            })
            this.$notify({
              message: 'Reservas desbloqueadas para: ' + dayToUnlock,
              duration: 6000,
              type: 'success',
            })
            await this.loadPois()
            this.closePanel()
          }
        })
    },

    async loadPois() {
      const PLACE_UUID = this.place.uuid || this.place.janooUserUuid
      await this.fetchPOIs({ PLACE_UUID: PLACE_UUID, PRODUCT_UUID: '' })
    },
  },

  async mounted() {
    await this.loadPois()
  },
}
</script>
<style>
@media screen and (min-width: 1580px) {
  .b-sidebar {
    min-width: 400px !important;
    width: 30% !important;
  }
}
@media screen and (max-width: 1580px) {
  .b-sidebar {
    min-width: 400px !important;
    width: 50% !important;
  }
}
@media screen and (max-width: 980px) {
  .b-sidebar {
    min-width: 400px !important;
    width: 20% !important;
  }
}
@media screen and (max-width: 930px) {
  .b-sidebar {
    min-width: 400px !important;
    width: 75% !important;
  }
}
@media screen and (max-width: 880px) {
  .b-sidebar {
    min-width: 400px !important;
    width: 75% !important;
  }
}
@media screen and (max-width: 780px) {
  .b-sidebar {
    min-width: 400px !important;
    width: 100% !important;
  }
}
.b-sidebar {
  min-width: 400px;
  -webkit-animation: slide-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  animation: slide-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

.b-sidebar.b-sidebar-right {
  right: -100px;
}

.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  border-top: 2px solid #cecece;
}

.section-title {
  font-size: large;
}

.grid-container > div {
  padding: 15px;
  border-radius: 8px;
}

.resumo-inside {
  display: flex;
  gap: 7px;
  justify-content: flex-start;
}

.total {
  text-transform: uppercase;
  font-weight: bold;
}

.thead {
  display: flex;
}
</style>
